const manutencao_de_parametro_do_ano_de_matricula = {
  path: "/manutencao-de-parametro-de-matricula-de-ano",
  redirect: "/manutencao-de-parametro-de-matricula-de-ano",
  meta: {
    breadCrumb: "Gerenciador de Parâmetro - Parâmetros de Atendimento",
  },
  children: [
    {
      path: "/manutencao-de-parametro-de-matricula-de-ano",
      name: "/manutencao_de_parametro_de_matricula_de_ano",
      meta: {
        allowedPermissions: ["parametros_ano_index"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeParametroDeAnoMatricula/ManutencaoDeParametroDeAnoMatricula.vue"
        ),
    },
  ],
};

export { manutencao_de_parametro_do_ano_de_matricula };
